import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "Login")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("strong", null, "Welcome to the GoTime Leave Management System!", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "GoTime is a web-based tool for employees to request or report time-off and track their benefit time usage.", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "It is also a tool for supervisors to be notified of time-off requested by employees, acknowledge their approval, or send it back for corrections.", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" For frequently asked questions, please take a look at our "),
  /*#__PURE__*/_createVNode("a", { href: "https://help.uillinois.edu/TDClient/37/uic/KB/ArticleDet?ID=2302" }, "FAQ page"),
  /*#__PURE__*/_createTextVNode("."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" For HR related and leave balance questions, please reach out to your department Human Resources."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" To report technical issues, please reach out to UIC Technology Solutions, make a ticket through our "),
  /*#__PURE__*/_createVNode("a", { href: "https://help.uillinois.edu/TDClient/37/uic/Requests/TicketRequests/NewForm?ID=fKLFxzKjW0Y_&RequestorType=ServiceOffering" }, "support form"),
  /*#__PURE__*/_createTextVNode("."),
  /*#__PURE__*/_createVNode("br")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "To enter the system, click the button below to log in.", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_GroupContainer = _resolveComponent("GroupContainer")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_GroupContainer, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _createVNode(_component_Button, {
          text: "Login",
          type: "submit",
          ariaLabel: "Login to GoTime",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.userLogin()))
        })
      ]),
      _: 1
    })
  ], 64))
}